import { ContextRoot } from '@lit-labs/context';

let isAttached = false;

/**
 * This function cover the late upgrade for context providers.
 * Check https://github.com/lit/lit/tree/main/packages/labs/context#late-upgraded-context-providers
 * for more details.
 */
export function attachContextRoot() {
	if (isAttached) {
		return;
	}

	const root = new ContextRoot();
	root.attach(document.body);

	isAttached = true;
}
